import channelService from "../../services/channel.service";
import service from '../../services/common.service';

function preloadUrl(channel){
    if (channel.LoadAction == "iframe") {
        var url = channelService.getChanelUrl(channel);

        if (url != "" && url != undefined && url != null) {
            return url;
        } 
    }else {
        return null;
    }
}

function hideIframe(channelName,channelId) {
    var dgElement = document.getElementById("digital-gate");
    var dataChannel = `${channelName} - ${channelId}`;
    var accountKey = window.dgAccountKey;

    var eventLog = { "channel": channelName, "evento": "Close channel", "status": "success" };
    service.saveEventLog(eventLog,accountKey)

    if (channelName && channelId) { 
        var channelWindow = dgElement.querySelector(`[data-channel='${dataChannel}']`);
        if ( channelWindow!= null) {
            channelWindow.classList.add("iframeDown");
        }
    }
}

if(!window.contentWindow){
    window.contentWindow = {};
}

window.contentWindow["preloadUrl"] = preloadUrl;
window.contentWindow["hideIframe"] = hideIframe;